<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item">
            <a class="navbar-brand" [routerLink]="['/']">
                <span class="brand-logo">
                    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
                </span>
            </a>
        </li>
    </ul>
    <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">

    <div class="bookmark-wrapper d-flex align-items-center">
        <ul class="nav navbar-nav ">
            <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
            <li class="nav-item d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
                <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
                    <span [data-feather]="'menu'" [class]="'ficon'"></span>
                </a>
            </li>
            <li class="nav-item ms-2" *ngIf="this.currentUser?.companyName">
                <div class="font-weight-bolder d-flex align-items-center company">Company:
                    {{this.currentUser?.companyName }}</div>
            </li>
        </ul>
    </div>
    <ul class="nav navbar-nav align-items-center ml-auto">

        <li class="nav-item d-none d-lg-block">
            <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
                <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'"
                    class="ficon font-medium-5 feather"></span>
            </a>
        </li>

        <li ngbDropdown class="nav-item dropdown-user">
            <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle
                id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
                <ng-container *ngIf="this.currentUser">
                    <div class="user-nav d-sm-flex d-none">

                        <span class="user-name font-weight-bolder">{{ this.currentUser.name}}</span>
                        <span class="user-status">{{ this.currentUser?.roles[0] | humanize }}</span>
                    </div>
                    <span class="avatar">

                        <img [src]="logo" id="logo-image" alt="avatar" style="height:40px; width:40px;">
                        <span class="avatar-status-online bg-primary"></span>
                    </span>
                </ng-container>
            </a>
            <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right"
                style="width: 13rem;">
                <a *ngIf="!this.currentUser?.isPasswordExpired" ngbDropdownItem
                    (click)="onChangePassword(ChangePassModal)"><span [data-feather]="'lock'"
                        [class]="'mr-50'"></span>Change Password</a>
                <a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span>
                    Logout</a>
            </div>


        </li>
        <!--/ User Dropdown -->
    </ul>
</div>
<ng-template #ChangePassModal>
    <div class="modal-header bg-primary">
        <h5 class="modal-title text-white"><i data-feather="lock" class="mr-50"></i>Change Password</h5>
        <button type="button" class="close" (click)="cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div [formGroup]="changePasswordForm" class="modal-body" tabindex="0" ngbAutofocus>
        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="errorMsg">
            <div class="alert-body">
                <p>{{ errorMsg }}</p>
            </div>
        </ngb-alert>

        <div class="form-group">
            <label [redStar]="changePasswordForm?.controls['existingPassword']"
                class="col-form-label col-form-label-sm">
                Existing Password
            </label>
            <div class="input-group input-group-merge form-password-toggle round">
                <input [formControlValidator]="changePasswordForm?.controls['existingPassword']"
                    [type]="existPasswordTextType ? 'text' : 'password'" formControlName="existingPassword"
                    class="form-control form-control-merge" placeholder="············" autocomplete="new-password"
                    (keypress)="detectFormControl('existingPassword')" (blur)="checkExistPass()" />
                <div class="input-group-append">
                    <span class="input-group-text cursor-pointer"
                        [ngStyle]="{'border-color': existPassInValid ? '#ea5455':''}">
                        <i class="feather font-small-4" [ngClass]="{
                                      'icon-eye-off': existPasswordTextType,
                                      'icon-eye': !existPasswordTextType
                                      }" (click)="toggleExistPasswordTextType()"></i></span>
                </div>
            </div>
            <arv-validation-messages for="existingPassword"></arv-validation-messages>
            <span style="font-size: 0.857rem; color: #ea5455;" *ngIf="errorMsgExistingPass">
                {{errorMsgExistingPass}}
            </span>
        </div>
        <div class="form-group">
            <label [redStar]="changePasswordForm?.controls['newPassword']" class="col-form-label col-form-label-sm">
                New Password
            </label>
            <div class="input-group input-group-merge form-password-toggle round">
                <input [formControlValidator]="changePasswordForm?.controls['newPassword']"
                    [type]="newPasswordTextType ? 'text' : 'password'" formControlName="newPassword"
                    class="form-control form-control-merge" placeholder="············"
                    (keypress)="detectFormControl('newPassword')" (blur)="checkNewtPass()" />
                <div class="input-group-append">
                    <span class="input-group-text cursor-pointer"
                        [ngStyle]="{'border-color': newPassInValid ? '#ea5455':''}">
                        <i class="feather font-small-4" [ngClass]="{
                                      'icon-eye-off': newPasswordTextType,
                                      'icon-eye': !newPasswordTextType
                                      }" (click)="toggleNewPasswordTextType()"></i></span>
                </div>
            </div>
            <arv-validation-messages for="newPassword"></arv-validation-messages>
            <span style="font-size: 0.857rem; color: #ea5455;" *ngIf="errorMsgNewPass">
                {{errorMsgNewPass}}
            </span>
        </div>
        <div class="form-group">
            <label [redStar]="changePasswordForm?.controls['confirmPassword']"
                class="col-form-label col-form-label-sm">Confirm Password</label>
            <div class="input-group input-group-merge form-password-toggle round">
                <input [formControlValidator]="changePasswordForm?.controls['confirmPassword']"
                    [type]="confirmPasswordTextType ? 'text' : 'password'" formControlName="confirmPassword"
                    class="form-control form-control-merge" placeholder="············"
                    (keypress)="detectFormControl('confirmPassword')" (blur)="checkConfirmPass()" />
                <div class="input-group-append">
                    <span class="input-group-text cursor-pointer"
                        [ngStyle]="{'border-color': confirmPassInValid ? '#ea5455':''}">
                        <i class="feather font-small-4" [ngClass]="{
                                          'icon-eye-off': confirmPasswordTextType,
                                          'icon-eye': !confirmPasswordTextType
                                          }" (click)="toggleConfirmPasswordTextType()"></i></span>
                </div>
            </div>
            <arv-validation-messages for="confirmPassword"></arv-validation-messages>
            <span class="text-danger" style="font-size:0.875em ;"
                *ngIf="changePasswordForm.getRawValue().confirmPassword != changePasswordForm.getRawValue().newPassword && !changePasswordForm.get('confirmPassword').errors && !changePasswordForm.get('newPassword').errors">
                Passwords don't match.
            </span>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary round" [disabled]="!changePasswordForm.valid" rippleEffect
            (click)="onSubmit()">
            <i data-feather="save" class="mr-50"></i>Update
        </button>
        <button type="button" class="btn btn-danger round" (click)="cancel()" rippleEffect>
            <i data-feather="x" class="mr-50"></i>Close
        </button>
    </div>
</ng-template>